import { FC, useEffect } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const Fourth: FC = () => {
    const { t } = useLang('xcode.xfusion.fourth');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneA = AniContainer.create({
                asyncFromTo: [
                    [`.ani_img .left`, { opacity: 0, x: -500 }, { opacity: 1, x: 0 }, 1],
                    [`.ani_img .right`, { opacity: 0, x: 500 }, { opacity: 1, x: 0 }, 1],
                ],
                asyncTimeLine: [1, 1],
                triggerElement: `#x-fusion-fourth`,
                triggerHook: 1,
                offset: '70%',
                duration: '20%',
            });
            AniContainer.scrollHandle(); //执行一次初始化
            return () => AniContainer.removeScene(sceneA);
        }
    }, []);

    return (
        <div className={styled.Fourth} id="x-fusion-fourth">
            <div className="content">
                <div className="ani_img">
                    <div className="left">
                        <div className="hexagon"></div>
                    </div>
                    <div className="center">
                        <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719227241600/Mask%20group%202.png" alt={t('title')} />
                    </div>
                    <div className="right">
                        <div className="hexagon"></div>
                    </div>
                </div>
                <div className="middle-central text_box">
                    <p className="title">{t('title')}</p>
                    <p className="font-desc">{t('subtitle')}</p>
                </div>
            </div>
        </div>
    );
};

export default Fourth;
